import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { DoorComponent } from 'src/app/models/components/objectComponents/DoorComponent';
import { GangwayDoorComponent } from 'src/app/models/components/objectComponents/GangwayDoorComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-gangwaydoor',
  templateUrl: './gangwaydoor.component.html',
  styleUrls: ['./gangwaydoor.component.scss']
})
export class GangwaydoorViewComponent extends BaseAdvancedPropertyViewComponent {
  door: DoorComponent;
  gangwayDoor: GangwayDoorComponent;
  doorOpeningTypes = [{ ID: 1, Name: "Open by default" }, { ID: 2, Name: "Automatic opening" }, { ID: 3, Name: "Manual opening" }];
  doorWingTypes = [{ ID: 1, Name: "Einflügelig" }, { ID: 2, Name: "Zweiflügelig" }];
  // indicator to hide propertys which are currently not available
  show: boolean = false;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.door = getComponentFromSource(ComponentNames.doorComponent, this.items);
    this.gangwayDoor = getComponentFromSource(ComponentNames.gangwayDoorComponent, this.items);
  }

  changeDoorWingType(selectedValue: number) {
    this.door.doorWingType = selectedValue;
  }

  changeDoorOpeningType(selectedValue: number) {
    this.gangwayDoor.doorOpeningType = selectedValue;
  }

  saveButtonDisabledState(): boolean {
    return false;
  }
}
